export default {
  pendingBillets: [],
  pendingBilletInformation: {},
  cities: [],
  segments: [],
};
